import { css } from '@emotion/react';
import { tokens } from '@domain-group/fe-brary';

const TILE_WIDTH = 104;
const TILE_HEIGHT = 40;
const { outer } = tokens.borderRadius;

export const group = css`
  display: flex;

  > label {
    box-sizing: border-box;
    width: ${TILE_WIDTH}px;
    height: ${TILE_HEIGHT}px;
    justify-content: center;

    &:first-of-type,
    &:first-of-type > span {
      border-radius: ${outer} 0 0 ${outer};
    }

    &:last-of-type,
    &:last-of-type > span {
      border-radius: 0 ${outer} ${outer} 0;
    }
  }
`;
